import { createSlice } from '@reduxjs/toolkit';

type PendingPatientState = {
  geocodeResponse: any | null;
  distanceEducatorId: string;
};

const initialState: PendingPatientState = {
  geocodeResponse: null,
  distanceEducatorId: ''
};

export const pendingPatientSlice = createSlice({
  name: 'pendingPatient',
  initialState,
  reducers: {
    setPendingPatientGeocodeResponse: (state, { payload }) => {
      state.geocodeResponse = payload ?? null;
    },
    setPendingPatientDistanceEducatorId: (state, { payload }: { payload: string }) => {
      state.distanceEducatorId = payload ?? '';
    },
    clearPendingPatientGeocodeResponse: (state) => {
      state.geocodeResponse = null;
      state.distanceEducatorId = '';
    }
  }
});

export const {
  setPendingPatientGeocodeResponse,
  setPendingPatientDistanceEducatorId,
  clearPendingPatientGeocodeResponse
} = pendingPatientSlice.actions;

export const pendingPatientState = (state: any) => state.pendingPatient;

export default pendingPatientSlice.reducer;
